<template>
  <div class="text-center">
    <i class="fa fa-fw fa-circle-notch fa-spin text-primary" :class="[`fa-${size}`]"></i>
  </div>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: "2x",
    },
  },
};
</script>

<style></style>
